import React from 'react';
import { mergeProps } from '../tableUtils';

interface TableBodyProps {
  page: any;
  prepareRow(row:any): any;
  loading: boolean;
}

export const TableBody: React.FC<TableBodyProps> = ({ page, prepareRow, loading }): JSX.Element => {
  return (
    <React.Fragment>
      <tbody>
        {page.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  if(loading) {
                    // https://cloudcannon.com/deconstructions/2014/11/15/facebook-content-placeholder-deconstruction.html
                    return (
                      <td {...cell.getCellProps()} className="ci" tabIndex="0" role="gridcell" style={{ height: '45px'}}>
                        <div className="h-100 d-flex align-items-center">
                          <div className="animated-background flex-fill"></div>
                        </div>
                      </td>);
                  } else {
                    return <td
                      {...mergeProps(
                        cell.getCellProps(),
                        {
                          className: `ci ${cell.column.className ? cell.column.className : ''}`,
                        }
                      )}
                      tabIndex="0" role="gridcell">
                      {cell.render('Cell')}
                    </td>
                  }
                })}
              </tr>
            )
        )}
      </tbody>
    </React.Fragment>
  );

}
